import React from 'react';

import { useSearchParams } from 'react-router-dom';



export function useTabSearchParams({
  paramName, defaultTabId
}: {
  defaultTabId: string;
  paramName: string;
}) {
  const [searchParams, setSearchParams] = useSearchParams();



  const tabId = React.useMemo(
    () => searchParams.get(paramName),
    [
      paramName,
      searchParams
    ]
  );

  const setTabId = React.useCallback(
    (newTabId: string) => {
      setSearchParams(val => {
        val.set(paramName, newTabId);
        return val;
      });
    },
    [paramName, setSearchParams]
  );

  React.useEffect(
    () => {
      if (!tabId) {
        if (defaultTabId) {
          setTabId(defaultTabId);
        } else {
          setSearchParams(val => {
            val.delete(paramName);
            return val;
          });
        }
      }
    },
    [
      defaultTabId,
      paramName,
      searchParams,
      setSearchParams,
      setTabId,
      tabId
    ]
  );



  return [
    tabId,
    setTabId
  ] as const;
}
